import {dashboardApi} from 'sources/api';
import {apiDateFormat} from 'utils/const';
import {resolveMetricTeamFilter} from 'actions/ExecDashboard.utils';

export default class DashBlacklistSource {
  static fetchBlacklist({startDate, endDate, teams}) {
    return dashboardApi.getJson(`/user_blacklist`, {
      params: {
        start_date: startDate.format(apiDateFormat),
        end_date: endDate.format(apiDateFormat),
        ...resolveMetricTeamFilter(teams),
      },
    });
  }
}
